<template>
    <div class="panel-content">
        <h2>Onze trots</h2>
        <p>Wij zijn trots op de samenwerking van de verschillende disciplines: radiochemici, radiobiologen, nucleaire en diverse andere geneeskundigen en de klinische fysici.</p>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    export default {

    };
</script>
